import React from "react";
import { Redirect, Route } from "react-router-dom";
import { logOut } from "../../store/modules/authSlice";
import { consts } from "../../common/consts";
import AutoLogout from "../auth/AutoLogout";
import api from "../../store/api";
import IAuthState from "../../interfaces/IAuthState";
export const isSMADriver = (userPermissions: string[]) => (userPermissions.includes(consts.Permissions.SMADriver) || userPermissions.includes(consts.Permissions.CustomerDriver));

export const redirectForSMADriver = (authStore: IAuthState, dispatch: any, component: any, props: any) => {
  const chooseVehiclePage = window.location.pathname.startsWith("/chooseVehicle");
  if (chooseVehiclePage) {
    return (
      <>
        <AutoLogout />
        {React.createElement(component, props)}
      </>
    );
  }

  // after log in if a drive doesn't have vehicle assign => go to select a vehicle page
  const vehicleId = authStore.vehicleSessionId;
  if (!vehicleId) {
    return <Redirect to={{ pathname: "/chooseVehicle" }} />;
  }

  const transferTripPage = window.location.pathname.startsWith("/transfertrip");
  if (transferTripPage) {
    return (
      <>
        <AutoLogout />
        {React.createElement(component, props)}
      </>
    );
  }
  const transferSchedule = window.location.pathname.startsWith("/transferschedule");
  if(transferSchedule)
  {
    return(
    <>
        <AutoLogout />
        {React.createElement(component, props)}
      </>
      );
  }
  const transferSchedules = window.location.pathname.startsWith("/transferSchedule");
  if(transferSchedules)
  {
    return(
    <>
        <AutoLogout />
        {React.createElement(component, props)}
      </>
      );
  }
  const shiftType = authStore.shiftType;
  const teamMembers = window.location.pathname.startsWith("/teamMembers");
  const transferDetails = window.location.pathname.startsWith("/transferDetails");
  const transferFullDetails = window.location.pathname.startsWith("/transferFullDetails");
  const dashboard = window.location.pathname.startsWith("/dashboard");
  const addbooking = window.location.pathname.startsWith("/addbooking");
  const addpcr = window.location.pathname.startsWith("/patientCareRecord");
  if (shiftType === 1 && (!transferSchedule)) {
    // Patient transport
    if (!teamMembers && !transferDetails && !transferFullDetails && !dashboard && !addbooking && !addpcr) {
      return <Redirect to={{ pathname: "/teamMembers" }} />;
    }
  } else if (shiftType === 2) {
    // Event Medical shift
    const ageCareCalloutForDrive = window.location.pathname.startsWith("/eventMedical");
    if (!transferDetails && !transferFullDetails && !dashboard && !addbooking && !addpcr && !ageCareCalloutForDrive) {
      return <Redirect to={{ pathname: "/eventMedical/route" }} />;
    }
  } else if (shiftType === 3) {
    // Aged Care/Medical Response
    const ageCareCalloutForDrive = window.location.pathname.startsWith("/agecarecalloutfordriver");
    if (!transferDetails && !transferFullDetails && !dashboard && !addbooking && !addpcr && !ageCareCalloutForDrive) {
      return <Redirect to={{ pathname: "/agecarecalloutfordriver" }} />;
    }
  } else if (shiftType === 4) {
    // Health Share shift
    const ageCareCalloutForDrive = window.location.pathname.startsWith("/healthShare");
    if (!transferDetails && !transferFullDetails && !dashboard && !addbooking && !addpcr && !ageCareCalloutForDrive) {
      return <Redirect to={{ pathname: "/healthShare/route" }} />;
    }
  }

  return (
    <>
      <AutoLogout />
      {React.createElement(component, props)}
    </>
  );
};
